/*
 * Copyright (C) Motorola Solutions, INC.
 * All Rights Reserved.
 */

export class Consts {
    public static RELOAD_MILLISECONDS = 10000;
    public static BROWSER_IDENTIFIER = 'browserIdentifier';
}
